// extracted by mini-css-extract-plugin
module.exports = {"stars":"styles_stars___121i","starWrapper":"styles_starWrapper__NsJ8P","partialFill":"styles_partialFill__YUEBe"};